module.exports = "<cat-panel>\n  <p>Form not ready yet...</p>\n</cat-panel>\n"


//////////////////
// WEBPACK FOOTER
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/ui-base/components/form-state-info/form-state-info.component.html
// module id = ../../../../../src/app/modules/ui-base/components/form-state-info/form-state-info.component.html
// module chunks = main